module.exports = __webpack_public_path__ + "media/images/Fav-blue-663940f43d27e9443928d2e379bb832a.svg";